import reducer from './reducers/index';
import routes from '../routes'
import * as incomeActions from './actions';
import * as incomeOperations from './operations';
import * as incomeSelectors from './selectors';

export {
    incomeOperations,
    incomeSelectors,
    incomeActions,
};

export default {
    reducer,
    routes
};
